import { Radar } from 'lucide-react';
import type { FeatureModule } from '../../app/feature-module';
import { ProspectingPage } from './pages/ProspectingPage';

export const prospectingModule: FeatureModule = {
  id: 'prospecting',
  label: 'Sinais',
  icon: Radar,
  basePath: '/sinais',
  routes: [{ path: '/', element: <ProspectingPage /> }],
  sidebarSection: 'workspace',
  requiredPermission: 'prospecting.read',
};
